import { createBrowserHistory } from "history";

export const browserHistory = createBrowserHistory();

// Navigate the browser to a path.
export const navigate = (path: string) => {
  browserHistory.push(path);
};
